export default {
  APP_TITLE: process.env.VUE_APP_TITLE,

  URL: process.env.VUE_APP_URL,
  API_URL: process.env.VUE_APP_API_URL,
  RESOURCE_URL: process.env.VUE_APP_RESOURCE_URL,

  report_type: {
    "financial": "Periodični Finansijski",
    "narative": "Periodični Narativni",
    "final_financial": "Finalni Finansijski",
    "final_narative": "Finalni Narativni",
  },
  report_status: {
    "pending": "Na čekanju",
    "processing": "Obrada u toku",
    "accepted": "Prihvaćen",
    "rejected": "Odbijen"
  },

  report_status_color: {
    "pending": "secondary",
    "processing": "info",
    "accepted": "success",
    "rejected": "danger"
  },
}